export { folderIconUploadRequest } from "./FolderIconUploadRequest";
export { getCroppedImg } from "./CropImage";
export { getTokenData } from "./GetTokenData";
export { lastIndexOf } from "./lastIndexOf";
export { FullImage } from "./FullImage";
export { getTokenDataUrl } from "./GetTokenDataUrl";

export const removeTags = (str: string) => str.replace(/(<([^>]+)>)/gm, "");
